import React from 'react'
import styled from 'styled-components'

// components
import NumBox from '../atom/numBox/NumBox'

// styles
import colors from '../../styles/colors'

// images
import ReloadIcon from '../../assets/image/button/ico-reload-g.svg'

export default function OrdersInformation({
  orderInfoData,
  timeDate,
  handleRefresh,
  isRefresh,
}) {
  return (
    <Wrapper>
      <HeadlineWrapper>
        <TitleHeadLine>실시간 주문 현황</TitleHeadLine>
        <DateAndRefreshHeadLine isRefresh={isRefresh}>
          <DateText>{timeDate}</DateText>
          <img
            src={ReloadIcon}
            alt=""
            id="loading-icon"
            onClick={handleRefresh}
          />
        </DateAndRefreshHeadLine>
      </HeadlineWrapper>
      <Order>
        <OrderItem>
          <HeaderOrder>결제금액</HeaderOrder>
          <BodyOrder>
            <span>
              {orderInfoData?.totalSalePrice
                ? orderInfoData.totalSalePrice.toLocaleString()
                : 0}
            </span>
            <span>{'원'}</span>
          </BodyOrder>
        </OrderItem>
        <OrderItem>
          <HeaderOrder>완료주문</HeaderOrder>
          <BodyOrder>
            <span>
              {orderInfoData?.orderCompleteCount
                ? orderInfoData.orderCompleteCount.toLocaleString()
                : 0}
            </span>
            <span>{'건'}</span>
          </BodyOrder>
        </OrderItem>
        <OrderItem>
          <HeaderOrder>취소금액</HeaderOrder>
          <BodyOrder>
            <span>
              {orderInfoData?.totalCancelPrice
                ? orderInfoData.totalCancelPrice.toLocaleString()
                : 0}
            </span>
            <span>{'원'}</span>
          </BodyOrder>
        </OrderItem>
        <OrderItem>
          <HeaderOrder>취소주문</HeaderOrder>
          <BodyOrder>
            <span>
              {orderInfoData?.orderCancelCount
                ? orderInfoData.orderCancelCount.toLocaleString()
                : 0}
            </span>
            <span>{'건'}</span>
          </BodyOrder>
        </OrderItem>
      </Order>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 477px;

  height: 194px;
  padding: 35px 30px 35px 15px;

  object-fit: contain;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: ${colors.W1};

  @media ${(props) => props.theme.tablet} {
    max-width: 482px;
  }

  @media (max-width: 800px) {
    align-self: center;
    padding: 35px 30px 35px 15px;
  }

  @media ${(props) => props.theme.mobile} {
    max-width: 320px;
    height: 201px;
    padding: 20px;
    margin: 0;
  }
`

const HeadlineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 38px;
  padding-left: 15px;

  @media ${(props) => props.theme.mobile} {
    padding-left: 0;
    margin-bottom: 19px;
  }
`

const TitleHeadLine = styled.div`
  color: ${colors.BK};
  font-weight: 700;

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const DateAndRefreshHeadLine = styled.div`
  display: flex;
  align-items: center;

  img {
    animation: ${(props) => props.isRefresh && 'animate 2s infinite'};
  }

  @keyframes animate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(720deg);
    }
  }
`

const DateText = styled.span`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: ${colors.G4};
  margin-right: 8px;

  @media ${(props) => props.theme.mobile} {
    margin-right: 4px;
  }
`

const Order = styled.div`
  display: flex;
  padding-left: 15px;
  justify-content: space-between;

  @media ${(props) => props.theme.mobile} {
    flex-wrap: wrap;
    padding-left: 0;
  }
`

const OrderItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    width: 50%;
    margin-bottom: 20px;
  }
`

const HeaderOrder = styled.div`
  margin-bottom: 18px;
  font-size: 14px;
  color: ${colors.BK};

  @media ${(props) => props.theme.mobile} {
    margin-bottom: 12px;
    font-size: 12px;
  }
`

const BodyOrder = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.BK};

  span:nth-child(1) {
    font-size: 20px;
    font-weight: 700;
  }

  span:nth-child(2) {
    margin-left: 3px;
    font-size: 14px;
  }
`
